import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TraumatologoVeterinarioAdra() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 cursor-pointer">Inicio</a>
            <i className="ri-arrow-right-s-line"></i>
            <a href="/zonas-servicio" className="hover:text-teal-600 cursor-pointer">Zonas de Servicio</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 font-semibold">Adra</span>
          </nav>
        </div>
      </div>

      <section className="relative bg-gradient-to-br from-teal-600 to-teal-800 text-white py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            <strong>Traumatólogo Veterinario en Adra</strong>
          </h1>
          <p className="text-xl text-teal-100 max-w-3xl leading-relaxed mb-8">
            Servicio móvil especializado de <strong>traumatología veterinaria en Adra</strong>. Cirugía TPLO, fracturas, luxaciones y ortopedia avanzada en tu clínica de <strong>Adra, Almería</strong>.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="/#contacto" className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer">
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a href="tel:+34600581975" className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-900 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line text-xl"></i>
              <span>Llamar: 600 581 975</span>
            </a>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                <strong>Especialista en Traumatología Veterinaria</strong> en Adra
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Como <strong>traumatólogo veterinario en Adra</strong>, ofrezco un servicio móvil completo que lleva la <strong>cirugía ortopédica especializada</strong> directamente a tu clínica en <strong>Adra, Almería</strong>.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Con más de <strong>25 años de experiencia</strong> y casi <strong>5000 cirugías realizadas</strong>, me especializo en procedimientos complejos de <strong>traumatología veterinaria</strong>: TPLO, fracturas, luxaciones, displasias y artroscopias.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Mi servicio de <strong>traumatología veterinaria móvil en Adra</strong> permite que tu clínica ofrezca procedimientos especializados sin necesidad de derivar a tus pacientes.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/c084cf5d5b4f1638096a7003945f0beb.jpg"
                alt="Traumatólogo veterinario Adra realizando cirugía TPLO"
                title="Traumatología veterinaria especializada Adra - Dr. Pablo Conejero"
                className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Servicios de Traumatología Veterinaria</strong> en Adra
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              <strong>Cirugía ortopédica especializada</strong> en tu clínica de <strong>Adra, Almería</strong>
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-heart-pulse-line',
                title: 'Cirugía TPLO',
                desc: 'Osteotomía de nivelación de meseta tibial para rotura de ligamento cruzado en Adra.',
                features: ['Técnica de referencia internacional', 'Recuperación funcional completa', 'Placas bloqueadas de última generación']
              },
              {
                icon: 'ri-bone-line',
                title: 'Fracturas Complejas',
                desc: 'Osteosíntesis avanzada con placas, clavos y fijadores externos en Adra.',
                features: ['Fracturas de fémur, tibia y húmero', 'Fijación interna y externa', 'Instrumental de precisión']
              },
              {
                icon: 'ri-pulse-line',
                title: 'Luxaciones',
                desc: 'Tratamiento quirúrgico de luxaciones de cadera, rótula y codo.',
                features: ['Luxación de rótula (grados II-IV)', 'Luxación coxofemoral', 'Técnicas de estabilización avanzadas']
              },
              {
                icon: 'ri-scissors-cut-line',
                title: 'Artroscopias',
                desc: 'Cirugía mínimamente invasiva para diagnóstico y tratamiento articular.',
                features: ['Menor trauma quirúrgico', 'Recuperación más rápida', 'Diagnóstico preciso']
              },
              {
                icon: 'ri-brain-line',
                title: 'Neurocirugía',
                desc: 'Hernias discales y compresiones vertebrales en Adra.',
                features: ['Hemilaminectomía', 'Descompresión medular', 'Urgencias neurológicas 24h']
              },
              {
                icon: 'ri-microscope-line',
                title: 'Oncología Ortopédica',
                desc: 'Resección de tumores óseos y amputaciones en Adra.',
                features: ['Osteosarcomas', 'Amputaciones oncológicas', 'Cirugía reconstructiva']
              }
            ].map((service, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>{service.title}</strong></h3>
                <p className="text-gray-600 leading-relaxed mb-4">{service.desc}</p>
                <ul className="space-y-2 text-sm text-gray-600">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Por Qué Elegir Mi <strong>Servicio de Traumatología</strong> en Adra?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-hospital-line', title: 'Servicio Móvil', desc: 'Llevo todo el equipamiento quirúrgico a tu clínica en Adra' },
              { icon: 'ri-award-line', title: '25 Años de Experiencia', desc: 'Más de 5000 cirugías como traumatólogo veterinario en Adra' },
              { icon: 'ri-24-hours-line', title: 'Disponibilidad 24h', desc: 'Atención de urgencias traumatológicas en Adra las 24 horas' },
              { icon: 'ri-tools-line', title: 'Equipamiento Avanzado', desc: 'Tecnología de última generación para traumatología veterinaria' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${item.icon} text-4xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3"><strong>{item.title}</strong></h3>
                <p className="text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Cobertura en Adra</strong> y Alrededores
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Servicio de <strong>traumatología veterinaria móvil</strong> en <strong>Adra</strong> y comarca
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {['Adra', 'La Alquería', 'Puente del Río', 'Las Albuferas', 'San Nicolás', 'Guainos Bajos', 'Guainos Altos', 'El Censo'].map((zona, index) => (
              <div key={index} className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-teal-200">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-2-fill text-teal-600"></i>
                  </div>
                  <span className="font-semibold text-gray-900">{zona}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <a href="/zonas-servicio" className="inline-flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">
              <span>Ver todas las zonas de servicio</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Necesitas un <strong>Traumatólogo Veterinario</strong> en Adra?
          </h2>
          <p className="text-xl text-teal-100 mb-8 leading-relaxed">
            Contacta conmigo para una valoración profesional o segunda opinión. Servicio de <strong>traumatología veterinaria especializada</strong> en tu clínica de <strong>Adra, Almería</strong>.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/#contacto" className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer">
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a href="tel:+34600581975" className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-900 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line text-xl"></i>
              <span>Llamar: 600 581 975</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}